export default __webpack_public_path__ + "static/media/baremetal_logo.9f63cbb2.png";